import { BillingDuration, BillingType } from '../App.constants';

class Util {
  getErrorMessage(error) {
    if (error && error.errorResponse && error.errorResponse.errors) {
      let errorString = '';
      error.errorResponse.errors.forEach((error) => {
        errorString += ' ' + error.message;
      });
      return errorString;
    } else {
      if (error && error.errorResponse) {
        return error.errorResponse.errorMessage;
      } else {
        return 'Unexpected Error, Please try again';
      }
    }
  }
  isValidUkPostalCode(test) {
    //check postcode format is valid
    //test = document.details.pcode.value;
    if (test == undefined) {
      return true;
    }
    let size = test.length;
    test = test.toUpperCase(); //Change to uppercase
    while (test.slice(0, 1) == ' ') {
      //Strip leading spaces
      test = test.substr(1, size - 1);
      size = test.length;
    }
    while (test.slice(size - 1, size) == ' ') {
      //Strip trailing spaces
      test = test.substr(0, size - 1);
      size = test.length;
    }
    //document.accountForm.postalCode.value = test; //write back to form field
    if (size < 6 || size > 8) {
      //Code length rule
      //$("#zipValMsg").text(test + " is not a valid postcode - wrong length");
      // $("#zipValMsg").text("Invalid postcode - wrong length");
      //document.accountForm.postalCode.focus();
      return false;
    }
    if (!isNaN(test.charAt(0))) {
      //leftmost character must be alpha character rule
      // $("#zipValMsg").text("Invalid postcode - cannot start with a number");
      //document.accountForm.postalCode.focus();
      return false;
    }
    if (isNaN(test.charAt(size - 3))) {
      //first character of inward code must be numeric rule
      // $("#zipValMsg").text("Invalid postcode - alpha character in wrong position");
      //document.accountForm.postalCode.focus();
      return false;
    }
    if (!isNaN(test.charAt(size - 2))) {
      //second character of inward code must be alpha rule
      // $("#zipValMsg").text("Invalid  postcode - number in wrong position");
      //document.accountForm.postalCode.focus();
      return false;
    }
    if (!isNaN(test.charAt(size - 1))) {
      //third character of inward code must be alpha rule
      // $("#zipValMsg").text("Invalid postcode - number in wrong position");
      //document.accountForm.postalCode.focus();
      return false;
    }
    if (!(test.charAt(size - 4) == ' ')) {
      //space in position length-3 rule
      // $("#zipValMsg").text("Invalid postcode - no space or space in wrong position");
      //document.accountForm.postalCode.focus();
      return false;
    }
    let count1 = test.indexOf(' ');
    let count2 = test.lastIndexOf(' ');
    if (count1 != count2) {
      //only one space rule
      // $("#zipValMsg").text("Invalid postcode - only one space allowed");
      //document.accountForm.postalCode.focus();
      return false;
    }
    return true;
  }

  isPermittedChars(s) {
    if (s == undefined) {
      return true;
    }
    var permittedChars =
      "-.',_/&#0123456789 AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯBⒷＢḂḄḆɃƂƁCⒸＣĆĈĊČÇḈƇȻꜾDⒹＤḊĎḌḐḒḎĐƋƊƉꝹEⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎFⒻＦḞƑꝻGⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾHⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍIⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗJⒿＪĴɈKⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢLⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀMⓂＭḾṀṂⱮƜNⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤOⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌPⓅＰṔṖƤⱣꝐꝒꝔQⓆＱꝖꝘɊRⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂSⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄTⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆUⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄVⓋＶṼṾƲꝞɅWⓌＷẀẂŴẆẄẈⱲXⓍＸẊẌYⓎＹỲÝŶỸȲẎŸỶỴƳɎỾZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢaⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐbⓑｂḃḅḇƀƃɓcⓒｃćĉċčçḉƈȼꜿↄdⓓｄḋďḍḑḓḏđƌɖɗꝺeⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝfⓕｆḟƒꝼgⓖｇǵĝḡğġǧģǥɠꞡᵹꝿhⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥiⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨıjⓙｊĵǰɉkⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣlⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇmⓜｍḿṁṃɱɯnⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥoⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵpⓟｐṕṗƥᵽꝑꝓꝕqⓠｑɋꝗꝙrⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃsⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛtⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇuⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉvⓥｖṽṿʋꝟʌwⓦｗẁẃŵẇẅẘẉⱳxⓧｘẋẍyⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿzⓩｚźẑżžẓẕƶȥɀⱬꝣꜲÆǼǢꜴꜶꜸꜺꜼǱǄǲǅǇǈǊǋƢꝎȢꜨꝠꜳæǽǣꜵꜷꜹꜻꜽǳǆƕǉǌƣȣꝏßꜩꝡ";
    for (var i = 0; i < s.length; i++) {
      if (permittedChars.indexOf(s.charAt(i)) == -1) return false;
    }
    return true;
  }

  isValidUsPostalCode(zip) {
    if (zip == undefined) {
      return true;
    }
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
  }

  isValidCanadaPostalCode(zip) {
    if (zip == undefined) {
      return true;
    }
    return /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test(zip);
  }

  membershipName(param) {
    switch (param) {
      case BillingDuration.DAY:
        return BillingType.DAILY;
      case BillingDuration.WEEK:
        return BillingType.WEEKLY;
      case BillingDuration.MONTH:
        return BillingType.MONTHLY;
      case BillingDuration.YEAR:
        return BillingType.ANNUAL;
      default:
        return '';
    }
  }
}

export default new Util();
